import React from 'react';
import { connect } from 'react-redux';

import OrderSimForm from '../OrderSimForm';
import { create, fetchProducts } from '../actions';
import { getUser } from 'reducers';

import styles from '../ordersim.module.css';
import { ATT_SIM_ID, VERIZON_SIM_ID, TMOBILE_SIM_ID } from '../../app_constants';

const SIMS_LIST = [ATT_SIM_ID, VERIZON_SIM_ID, TMOBILE_SIM_ID];

class OrderSim extends React.Component {

  componentDidMount() {
    this.props.fetchProducts(SIMS_LIST);
  }

  handleSubmit = (values, dispatch) => {
    const { create, user } = this.props;
    return create({
      user,
      ...transformData(values),
    })
  }

  render() {
    return (
      <div className={styles.orderSim}>
        <div className={styles.titleWrapper}>
          <h1 className={styles.title}> Order SIM </h1>
        </div>
        <OrderSimForm
          onSubmit={this.handleSubmit}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const user = getUser(state);

  return {
    user,
  }
};

const mapDispatchToProps = {
  create,
  fetchProducts,
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderSim);

export const getProductId = (type) => {
  const mapTypeToId = {
    att: ATT_SIM_ID,
    verizon: VERIZON_SIM_ID,
    tmobile: TMOBILE_SIM_ID,
  }
  
  return mapTypeToId[type];
}

export const getShippingOptions = (type) => {
  if (type === 'regular') {
    return {
      shipping_carrier: 'stamps_com',
      shipping_service: 'usps_priority_mail'
    }
  }
  else if (type === 'overnight') {
    return {
      shipping_carrier: 'fedex',
      shipping_service: 'fedex_standard_overnight'
    }
  }
  else {
    return {
      shipping_carrier: 'fedex',
      shipping_service: 'fedex_2day'
    }
  }
}

export const formatShippingDetails = (shippingDetails) => {
  return {
    ...shippingDetails,
    address_type: 'BILLING',
  }
}

export const transformData = (values) => {
  const { type, shippingMethod, quantity, ...shippingDetails } = values;
  return {
    shippingOptions: getShippingOptions(shippingMethod),
    productAttrs: {
      item_id: getProductId(type),
      item_type: 'product',
    },
    shippingDetails: formatShippingDetails(shippingDetails),
    quantity,
  }
}
